module.exports = __webpack_public_path__ + "static/media/cq_plus.235b4bb9.svg";